import Blue from "~/core";

const widgetRelations = [];

const setupAccordion = (accordion, relations, toggle) => {
  const items = [...accordion.querySelectorAll(".accordion__item")];

  items.forEach((container) => {
    let trigger = container.querySelector(".accordion__trigger");
    let content = container.querySelector(".accordion__content");
    let config = {
      container,
      trigger,
      content,
      relations,
    };
    relations.push(new toggle(config));
  });
};

new Blue({
  name: "Accordion",
  selector: ".accordion:not(.accordion--widget)",
  setup(accordion) {
    setupAccordion(accordion, [], this.$toggle);
  },
});

new Blue({
  name: "AccordionWidget",
  selector: ".accordion--widget",
  setup(accordion) {
    setupAccordion(accordion, widgetRelations, this.$toggle);
  },
});
